import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsHomeButtonControl } from "../ags-home-button-control";

export class AgsHomeButtonControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return layer.getFlexiButton("ags_home") != null;
    }

    public build(layer: Layers): AgsHomeButtonControl[] {
        return [new AgsHomeButtonControl(layer.getFlexiButton("ags_home"))];
    }
}
